import React from 'react'
import {useToast} from '../contexts/ToastContext'
import Icon from './Text/Icon'

const typeStyles={
    error: {bg: 'bg-danger',icon: 'exclamation-circle-fill'},
    success: {bg: 'bg-green-500',icon: 'check-circle-fill'},
    warning: {bg: 'bg-yellow-500',icon: 'exclamation-triangle-fill'},
    info: {bg: 'bg-primary',icon: 'info-circle-fill'}
}

export default function ToastContainer() {
    const {toasts,removeToast}=useToast()

    if(toasts.length===0) return null

    return (
        <div className='fixed bottom-5 right-2 left-2 lg:top-4 lg:bottom-auto lg:right-4 lg:left-auto z-50 flex flex-col gap-2'>
            {toasts.map((toast) => {
                const style=typeStyles[toast.type]||typeStyles.error
                return (
                    <div key={toast.id} className='flex items-center justify-start rounded-lg shadow-md bg-light animate-slide-in'>
                        <div className={`px-4 py-2 h-full rounded-l-lg ${style.bg}`}>
                            <Icon icon={style.icon} className='inline text-xl !px-0 text-light' />
                        </div>
                        <p className='inline pr-4 pl-3 text-sm text-dark'>
                            {toast.message}
                        </p>
                        <div className='m-2 cursor-pointer' onClick={() => removeToast(toast.id)}>
                            <Icon icon='x' className='text-lg' />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
